(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3632],{

/***/ 48285:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["Z"] = (stylis_min);


/***/ }),

/***/ 40351:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 41926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GetArticles; },
/* harmony export */   "n": function() { return /* binding */ GetArticleBySlug; }
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81621);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query GetArticles($categorySlug: String!, $limit: Float!) {\n    getArticles(categorySlug: $categorySlug, limit: $limit) {\n      articles {\n        id\n        title\n        slug\n        cover_image\n        position\n        created_at\n        view\n        thumbnail\n        description_body\n        seo_description\n        seo_title\n      }\n      amount\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  query GetArticleBySlug($articleSlug: String!) {\n    getArticleBySlug(articleSlug: $articleSlug) {\n      id\n      title\n      slug\n      seo_title\n      seo_image\n      seo_description\n      position\n      created_at\n      view\n      thumbnail\n      cover_image\n      description_body\n      drop_lead_delay_minutes\n      is_pinned\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var GetArticles = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject());
var GetArticleBySlug = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 12713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ GetCollectionBySlug; }
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81621);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCollectionBySlug($slug: String!, $apiKey: String!) {\n    getCollectionBySlug(slug: $slug, apiKey: $apiKey) {\n      id\n      name\n      cover_image\n      thumbnail\n      description\n      packages {\n        id\n        name\n        slug\n        status\n        thumbnail\n        products {\n          id\n          name\n          description\n          product_variants {\n            plan_product_variants {\n              premium_price\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var GetCollectionBySlug = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 46998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qv": function() { return /* binding */ commaFormat; },
/* harmony export */   "SZ": function() { return /* binding */ commaFixedFormat; },
/* harmony export */   "xu": function() { return /* binding */ formatNumericSting; }
/* harmony export */ });
var commaFormat = function(num) {
    var isRoundUp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isFloat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, toFixed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var value = isRoundUp ? Math.ceil(num) : Math.round(num);
    if (isFloat) {
        return parseFloat(value).toLocaleString(undefined, {
            maximumFractionDigits: 2
        });
    }
    if (toFixed) {
        return num.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else if (toFixed !== false && toFixed >= 1) {
        return num.toLocaleString(undefined, {
            minimumFractionDigits: toFixed,
            maximumFractionDigits: toFixed
        });
    }
    return parseInt(value).toLocaleString(undefined, {
        maximumFractionDigits: 2
    });
};
var commaFixedFormat = function(num) {
    var toFixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return commaFormat(num, false, false, toFixed);
};
var formatNumericSting = function(cover) {
    try {
        // scan having any numeric inside string if no just return string
        if (!/\d/gi.test(cover)) return cover;
        // scan if having no wording found return formatted numeric
        if (!/(?!^\d+$)^.+$/gi.test(cover)) return commaFormat(cover);
        // separated out by replacing digits and text
        var string = cover.replace(/\d/gi, "");
        var numeric = cover.replace(/\D/gi, "");
        // return both of them with formatted
        return "".concat(commaFormat(+numeric)).concat(string);
    } catch (err) {
        console.warn("couldn't format numeric string string", err);
    }
};


/***/ }),

/***/ 92742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/home/product-carousel/product_carousel.module.css
var product_carousel_module = __webpack_require__(72021);
var product_carousel_module_default = /*#__PURE__*/__webpack_require__.n(product_carousel_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-elastic-carousel/dist/index.es.js + 4 modules
var index_es = __webpack_require__(9980);
// EXTERNAL MODULE: ./helpers/utility/number_utility.js
var number_utility = __webpack_require__(46998);
// EXTERNAL MODULE: ./helpers/utility/class_name.js
var class_name = __webpack_require__(98078);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 3 modules
var useQuery = __webpack_require__(55850);
// EXTERNAL MODULE: ./graphql/query/collections.js
var collections = __webpack_require__(12713);
// EXTERNAL MODULE: ./node_modules/underscore/modules/index-all.js + 160 modules
var index_all = __webpack_require__(36005);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton_Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./components/home/product-carousel/product_carousel.js












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function ProductCarousel(param1) {
    var productList = param1.productList;
    var router = (0,next_router.useRouter)();
    var noArrow = function(param) {
        var type = param.type, onClick = param.onClick, isEdge = param.isEdge;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}));
    };
    var breakPoint = [
        {
            width: 1,
            itemsToShow: 1.2
        },
        {
            width: 600,
            itemsToShow: 2.2
        },
        {
            width: 900,
            itemsToShow: 4
        }, 
    ];
    var onProductClickHandler = function(e, slug) {
        router.push("/products/".concat(slug));
    };
    (0,react.useEffect)(function() {
        var pdElemImgWrapper = document.querySelectorAll(".image_wrapper");
        var setHeight = function(elem) {
            elem.forEach(function(dom) {
                var width = Math.round(dom.getBoundingClientRect().width);
                dom.style.height = width + "px";
            });
        };
        setTimeout(function() {
            setHeight(pdElemImgWrapper);
        }, 100);
        window.addEventListener("resize", function() {
            setTimeout(function() {
                setHeight(pdElemImgWrapper);
            }, 100);
        });
    }, [
        productList
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (product_carousel_module_default()).product_carousel,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (product_carousel_module_default()).title,
                    children: "แผนความคุ้มครอง"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (product_carousel_module_default()).carousel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        showEmptySlots: true,
                        itemPadding: [
                            0,
                            12
                        ],
                        renderArrow: noArrow,
                        breakPoints: breakPoint,
                        children: productList ? productList.map(function(product, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: (product_carousel_module_default()).product_card,
                                onClick: function(e) {
                                    return onProductClickHandler(e, product.slug);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,class_name.className)((product_carousel_module_default()).product_image_wrapper, "image_wrapper"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            alt: product.tile,
                                            src: product.image,
                                            layout: "fill",
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (product_carousel_module_default()).product_details,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: product.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "เบี้ยเริ่มต้น ",
                                                    (0,number_utility/* commaFormat */.Qv)(product.price),
                                                    " บาท "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        }) : index_all/* default.range */.ZP.range(4).map(function(index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: (product_carousel_module_default()).skeleton_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "rectangular",
                                        width: "100%",
                                        height: 225
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1.125rem'
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1rem'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            ]
        })
    }));
}
function ProductCarouselContainer() {
    var data = (0,useQuery/* useQuery */.a)(collections/* GetCollectionBySlug */.p, {
        variables: {
            apiKey: "f9459e5d-1399-4282-852c-90df6b256d13",
            slug: "landing-page-product"
        }
    }).data;
    var ref3 = (0,react.useState)(), productList = ref3[0], setProductList = ref3[1];
    (0,react.useEffect)(function() {
        var ref13;
        if (!data) return;
        var ref1;
        var _filteredPackages = (ref1 = (ref13 = data.getCollectionBySlug.packages) === null || ref13 === void 0 ? void 0 : ref13.filter(function(_package) {
            return _package.status === 1;
        })) !== null && ref1 !== void 0 ? ref1 : [];
        var ref2;
        var _productsRemap = (ref2 = _filteredPackages === null || _filteredPackages === void 0 ? void 0 : _filteredPackages.map(function(_package) {
            var _Math;
            var ref, ref4, ref5, ref6, ref7;
            var priceArr = (ref = _package.products[0]) === null || ref === void 0 ? void 0 : (ref4 = ref.product_variants) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.plan_product_variants;
            var priceList = priceArr === null || priceArr === void 0 ? void 0 : priceArr.map(function(planVariant) {
                return planVariant.premium_price;
            });
            var ref8, ref9, ref10, ref11, ref12;
            return {
                slug: (ref8 = _package === null || _package === void 0 ? void 0 : _package.slug) !== null && ref8 !== void 0 ? ref8 : "",
                id: (ref9 = _package === null || _package === void 0 ? void 0 : (ref6 = _package.products) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.id) !== null && ref9 !== void 0 ? ref9 : "",
                image: (ref10 = _package === null || _package === void 0 ? void 0 : _package.thumbnail) !== null && ref10 !== void 0 ? ref10 : "",
                price: !priceList ? "" : (ref11 = (_Math = Math).min.apply(_Math, _toConsumableArray(priceList))) !== null && ref11 !== void 0 ? ref11 : "",
                title: (ref12 = _package === null || _package === void 0 ? void 0 : _package.name) !== null && ref12 !== void 0 ? ref12 : ""
            };
        })) !== null && ref2 !== void 0 ? ref2 : [];
        setProductList(_productsRemap);
    }, [
        data
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel, {
        productList: productList
    }));
};

// EXTERNAL MODULE: ./components/home/testimonial-carousel/testimonial_carousel.module.css
var testimonial_carousel_module = __webpack_require__(77379);
var testimonial_carousel_module_default = /*#__PURE__*/__webpack_require__.n(testimonial_carousel_module);
;// CONCATENATED MODULE: ./components/home/testimonial-carousel/testimonial_carousel.js





function TestimonialCarousel() {
    var noArrow = function(param) {
        var type = param.type, onClick = param.onClick, isEdge = param.isEdge;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}));
    };
    var noPaginate = function(param) {
        var pages = param.pages, activePage = param.activePage, onClick = param.onClick;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}));
    };
    var breakPoint = [
        {
            width: 1,
            itemsToShow: 1.2
        },
        {
            width: 600,
            itemsToShow: 2
        },
        {
            width: 900,
            itemsToShow: 3
        }, 
    ];
    var testimonialUser = [
        {
            id: 1,
            imageUrl: "/assets/icon-png/testimonial/testimonial1.webp",
            name: "Thong Wongthatchai",
            feedback: "ซื้อประกันเพื่อที่อยู่อาศัย ทิพยประกันภัย ที่ TQM home ซื้อออนไลน์ง่าย  เบี้ยถูกดีครับ"
        },
        {
            id: 2,
            imageUrl: "/assets/icon-png/testimonial/testimonial2.webp",
            name: "Phiraya YY",
            feedback: "เป็นลูกค้าทีคิวเอ็มฯปีแรกค่ะ แนะนำดีมาก ตรงกับความต้องการ และราคาสมเหตุสมผล"
        },
        {
            id: 3,
            imageUrl: "/assets/icon-png/testimonial/testimonial3.webp",
            name: "Supattira M",
            feedback: "ประกันบ้านกับ TQM แล้ว อุ่นใจมากค่ะ ปีนี้ต่อเป็นปีที่ 2 แล้ว"
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
            itemPadding: [
                0,
                12
            ],
            renderArrow: noArrow,
            pagination: false,
            breakPoints: breakPoint,
            className: (testimonial_carousel_module_default()).testimonial_carousel,
            children: testimonialUser.map(function(user) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: (testimonial_carousel_module_default()).card,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (testimonial_carousel_module_default()).image_wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: user.imageUrl,
                                alt: "feedback of ".concat(user.name),
                                width: 56,
                                height: 56
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (testimonial_carousel_module_default()).detail,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: user.feedback
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (testimonial_carousel_module_default()).user_name,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                children: user.name
                            })
                        })
                    ]
                }, user.id);
            })
        })
    }));
};

// EXTERNAL MODULE: ./components/home/article/article-carousel.module.css
var article_carousel_module = __webpack_require__(26684);
var article_carousel_module_default = /*#__PURE__*/__webpack_require__.n(article_carousel_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./graphql/query/articles.js
var query_articles = __webpack_require__(41926);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/home/article/article-carousel.js









function ArticleCarousel(param1) {
    var articleList = param1.articleList;
    var noArrow = function(param) {
        var type = param.type, onClick = param.onClick, isEdge = param.isEdge;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}));
    };
    var noPaginate = function(param) {
        var pages = param.pages, activePage = param.activePage, onClick = param.onClick;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_carousel_module_default()).articles_carousel_container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                renderArrow: noArrow,
                children: articleList.map(function(article) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/articles/".concat(article.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (article_carousel_module_default()).article_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (article_carousel_module_default()).image_wrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: article.imageUrl,
                                            layout: "fill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (article_carousel_module_default()).content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: article.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: article.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, article.id);
                })
            })
        })
    }));
}
function ArticleCarouselContainer() {
    var ref2 = (0,useQuery/* useQuery */.a)(query_articles/* GetArticles */.d, {
        variables: {
            categorySlug: "หมีรักบ้าน",
            limit: 3
        }
    }), articles = ref2.data, error = ref2.error;
    var ref1 = (0,react.useState)(), articleList = ref1[0], setArticleList = ref1[1];
    (0,react.useEffect)(function() {
        if (!articles) return;
        var articleContentFormat = function(content) {
            var ref;
            if (!content) return '';
            var htmlStrip = /(<[^>]*>|\&nbsp|\&ldquo|\&rdquo|;)/ig;
            return ((ref = content.replace(htmlStrip, '')) === null || ref === void 0 ? void 0 : ref.substring(0, 250)) + '...';
        };
        var _articles = articles.getArticles.articles.map(function(obj) {
            return {
                id: obj.id,
                imageUrl: obj.thumbnail,
                title: obj.title,
                heading: obj.title,
                description: articleContentFormat(obj.description_body),
                slug: obj.slug
            };
        });
        setArticleList(_articles);
    }, [
        articles
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: articleList && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCarousel, {
            articleList: articleList
        })
    }));
};

// EXTERNAL MODULE: ./helpers/constant/content_data.js
var content_data = __webpack_require__(53597);
// EXTERNAL MODULE: ./components/home/partner-deals/partner_deals.module.css
var partner_deals_module = __webpack_require__(89556);
var partner_deals_module_default = /*#__PURE__*/__webpack_require__.n(partner_deals_module);
;// CONCATENATED MODULE: ./components/home/partner-deals/partner_deals.js




function PartnerDeals() {
    var ref = (0,react.useState)([
        content_data/* partners.0 */.pS[0]
    ]), partnerList = ref[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (partner_deals_module_default()).partner_deals,
            children: partnerList && partnerList.map(function(partner) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (partner_deals_module_default()).partner_card,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (partner_deals_module_default()).partner_image_wrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: partner.target,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: partner.title,
                                src: partner.image
                            })
                        })
                    })
                }, partner.id);
            })
        })
    }));
};

// EXTERNAL MODULE: ./components/home/insurance-ease/insurance_ease.module.css
var insurance_ease_module = __webpack_require__(70017);
var insurance_ease_module_default = /*#__PURE__*/__webpack_require__.n(insurance_ease_module);
// EXTERNAL MODULE: ./components/UI/button/button.js
var button_button = __webpack_require__(88944);
// EXTERNAL MODULE: ./components/common/droplead-modal/droplead_modal.js
var droplead_modal = __webpack_require__(50220);
;// CONCATENATED MODULE: ./components/home/insurance-ease/insurance_ease.js









function InsuranceEase() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(), isOpenDropLeadModal = ref[0], setIsOpenDropLeadModal = ref[1];
    var onClickHandler = function() {
        router.push("/calculate-plan/home-info");
    };
    var onDropLeadModalOpenHandler = function() {
        setIsOpenDropLeadModal(true);
    };
    var easeIcons = [
        {
            id: 1,
            imageUrl: "/assets/icon-png/overall-ease.png",
            title: "แผนประกันภัยที่ครอบคลุมทุกความต้องการ"
        },
        {
            id: 2,
            imageUrl: "/assets/icon-png/installment.png",
            title: "จ่ายสะดวกได้หลายช่องทาง"
        },
        {
            id: 3,
            imageUrl: "/assets/icon-png/all-time.png",
            title: "ปรึกษาฟรี! 24 ชั่วโมง"
        },
        {
            id: 4,
            imageUrl: "/assets/icon-png/easy-claim.png",
            title: "เคลมสะดวก ดูแลทุกผลประโยชน์ของคุณ"
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (insurance_ease_module_default()).insurance_ease,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(droplead_modal/* default */.Z, {
                    isOpen: isOpenDropLeadModal,
                    setIsOpen: setIsOpenDropLeadModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (insurance_ease_module_default()).insurance_ease_cta_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (insurance_ease_module_default()).title,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: "ประกันอัคคีภัย TQM Home"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        "คุ้มครองบ้านและทรัพย์สินจากเหตุไม่คาดฝัน",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (insurance_ease_module_default()).incident_carousel,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* default */.Z, {
                                                verticalMode: true,
                                                showArrows: false,
                                                pagination: false,
                                                enableAutoPlay: false,
                                                preventDefaultTouchmoveEvent: true,
                                                itemsToShow: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "ไฟไหม้ อัคคีภัย"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "น้ำท่วม"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "เครื่องใช้ไฟฟ้าช็อต"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (insurance_ease_module_default()).ease_items,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (insurance_ease_module_default()).ease_items_cointainer,
                                children: easeIcons.map(function(ease) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                        className: (insurance_ease_module_default()).ease_item,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (insurance_ease_module_default()).ease_icon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    src: ease.imageUrl,
                                                    layout: "fill",
                                                    objectFit: "contain"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: ease.title
                                            })
                                        ]
                                    }, ease.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (insurance_ease_module_default()).ease_btn_group,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (insurance_ease_module_default()).ease_main_cta,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, {
                                        color: "blue",
                                        text: "คำนวณแผนประกัน",
                                        onClick: onClickHandler
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (insurance_ease_module_default()).ease_drop_lead,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, {
                                        color: "transparent",
                                        text: "ต้องการคำแนะนำจากพนักงาน",
                                        onClick: onDropLeadModalOpenHandler
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (insurance_ease_module_default()).bear_mascot,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: "/assets/images/ease-mascot-graphic.png",
                        layout: "fill",
                        objectFit: "contain"
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@react-hook/media-query/dist/module/index.js
var dist_module = __webpack_require__(84990);
// EXTERNAL MODULE: ./components/home/partner-insurer-carousel/partner_insurer_carousel.module.css
var partner_insurer_carousel_module = __webpack_require__(31751);
var partner_insurer_carousel_module_default = /*#__PURE__*/__webpack_require__.n(partner_insurer_carousel_module);
;// CONCATENATED MODULE: ./components/home/partner-insurer-carousel/partner_insurer_carousel.js





function PartnerInsurerCarousel() {
    var partnerList = [
        {
            id: 1,
            imageAlt: "วิิริยะประกันภัย",
            image: "/assets/images/partners/viriya.png"
        },
        {
            id: 2,
            title: "ไทยวิวัฒ",
            image: "/assets/images/partners/thaivivat.png"
        },
        {
            id: 3,
            title: "เมืองไทยปประกันชีวิต",
            image: "/assets/images/partners/muangthai.png"
        },
        {
            id: 4,
            title: "Aliance ayudhya",
            image: "/assets/images/partners/alliance.png"
        },
        {
            id: 5,
            title: "msig",
            image: "/assets/images/partners/msig.png"
        },
        {
            id: 6,
            title: "Aioi Bangkok",
            image: "/assets/images/partners/aioi.png"
        },
        {
            id: 7,
            title: "Cigna",
            image: "/assets/images/partners/cigna.png"
        },
        {
            id: 8,
            title: "กรุงเเทพประกันภัย",
            image: "/assets/images/partners/bangkok.png"
        }, 
    ];
    var mobile = (0,dist_module/* useMediaQueries */.l)({
        screen: "screen",
        min: "(min-width: 0px)",
        max: "(max-width: 1023px)"
    });
    var monitor = (0,dist_module/* useMediaQueries */.l)({
        screen: "screen",
        min: "(min-width: 1024px)"
    });
    var noArrow = function(param) {
        var type = param.type, onClick = param.onClick, isEdge = param.isEdge;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (partner_insurer_carousel_module_default()).partner_insurer_carousel,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (partner_insurer_carousel_module_default()).title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "แผนประกันจากเหล่าพันธมิตรชั้นนำกว่า 40 แห่ง"
                    })
                }),
                mobile.matchesAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    outerSpacing: -10,
                    renderArrow: noArrow,
                    itemsToShow: 4,
                    itemPadding: [
                        16,
                        16
                    ],
                    className: (partner_insurer_carousel_module_default()).carousel_slider_container,
                    children: partnerList.map(function(_partner, index) {
                        if (index % 2 === 0) return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (partner_insurer_carousel_module_default()).partner_col,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (partner_insurer_carousel_module_default()).partner_card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partner_insurer_carousel_module_default()).partner_image_wrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: partnerList[index].image
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (partner_insurer_carousel_module_default()).partner_card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (partner_insurer_carousel_module_default()).partner_image_wrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: partnerList[index + 1].image
                                            })
                                        })
                                    })
                                })
                            ]
                        }, index));
                    })
                }),
                monitor.matchesAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    outerSpacing: -10,
                    itemsToShow: 8,
                    itemPadding: [
                        24,
                        24
                    ],
                    className: (partner_insurer_carousel_module_default()).carousel_slider_container,
                    children: partnerList.map(function(partner) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: (partner_insurer_carousel_module_default()).partner_card,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (partner_insurer_carousel_module_default()).partner_image_wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: partner.image
                                    })
                                })
                            })
                        }, partner.id);
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/home/buy-steps/buy_step.module.css
var buy_step_module = __webpack_require__(5517);
var buy_step_module_default = /*#__PURE__*/__webpack_require__.n(buy_step_module);
;// CONCATENATED MODULE: ./components/home/buy-steps/buy_steps.js



function BuySteps() {
    var buyStep = [
        {
            id: 1,
            title: "ค้นหาตำแหน่งบ้านเพื่อเช็กความเสี่ยง",
            description: "ระบุตำแหน่งพื้นที่บ้านคร่าวๆ ก็สามารถเช็กความเสี่ยงและเลือกความคุ้มครองที่คุณต้องการได้"
        },
        {
            id: 2,
            title: "คำนวณเบี้ยประกัน",
            description: "เพียงระบุขนาด ประเภทบ้าน ระบบจะคำนวณเบี้ยประกันที่เหมาะสมเฉพาะบ้านคุณ"
        },
        {
            id: 3,
            title: "เปรียบเทียบแผนประกัน",
            description: "เปรียบเทียบราคาและความคุ้มครองเพื่อเลือกแผนที่ใช่"
        },
        {
            id: 4,
            title: "ชำระเงิน",
            description: "ชำระได้หลายช่องทางทั้งบัตรเดบิต เครดิต และคิวอาร์โค้ด"
        },
        {
            id: 5,
            title: "รับกรมธรรม์",
            description: "เลือกช่องทางการรับกรมธรรม์ได้ทางอีเมลและไปรษณีย์"
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (buy_step_module_default()).buy_steps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (buy_step_module_default()).title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "5 ขั้นตอนซื้อประกันบ้านออนไลน์ด้วยตนเอง"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (buy_step_module_default()).buy_step_items,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (buy_step_module_default()).buy_step_items_container,
                        children: buyStep.map(function(step, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                className: (buy_step_module_default()).buy_step,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (buy_step_module_default()).buy_step_heading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            children: [
                                                "0",
                                                step.id
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (buy_step_module_default()).buy_step_details,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (buy_step_module_default()).buy_step_details_title,
                                                children: step.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (buy_step_module_default()).buy_step_details_description,
                                                children: step.description
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(40821);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
;// CONCATENATED MODULE: ./components/home/curation-carousel/curation_carousel.js











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CurationBannerCarousel(param1) {
    var carouselItem = param1.carouselItem;
    var router = useRouter();
    var ref1 = useState(false), intervalOnce = ref1[0], setIntervalOnce = ref1[1];
    var curationCarouselRef = useRef(null);
    var breakPoint = [
        {
            width: 1,
            itemsToShow: 1
        },
        {
            width: 768,
            itemsToShow: 2
        }, 
    ];
    useEffect(function() {
        if (intervalOnce && carouselItem) return;
        // set loop back to first item if scrolled to last one by counting time
        // Todo find the better way instead of using interval (find better lib)
        // reference to base transition time was 500 and autoplay was 2000 each
        var totalTimeToAnimateToLastPate = (carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.length) * (500 + 2000);
        setInterval(function() {
            if (!curationCarouselRef) return;
            curationCarouselRef.goTo(0);
        }, totalTimeToAnimateToLastPate);
        setIntervalOnce(true);
    });
    var noArrow = function(param) {
        var type = param.type, onClick = param.onClick, isEdge = param.isEdge;
        return(/*#__PURE__*/ _jsx(Fragment, {}));
    };
    var onBannerClickHandler = function(e, url, target) {
        router.push(url);
    };
    return(/*#__PURE__*/ _jsx(Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: style.curation_carousel_wrapper,
            children: /*#__PURE__*/ _jsx(Carousel, {
                itemsToShow: 2,
                itemPadding: [
                    0,
                    12,
                    0,
                    12
                ],
                showArrows: false,
                renderArrow: noArrow,
                breakPoints: breakPoint,
                enableAutoPlay: true,
                ref: function(ref) {
                    return curationCarouselRef = ref;
                },
                children: carouselItem ? carouselItem.map(function(carouselBanner, index) {
                    /*#__PURE__*/ return _jsx("div", {
                        className: style.carousel_banner_wrapper,
                        onClick: function(e) {
                            return onBannerClickHandler(e, carouselBanner.linkUrl, carouselBanner.linkTarget);
                        },
                        children: /*#__PURE__*/ _jsx("div", {
                            className: style.carousel_banner_image,
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: carouselBanner.image,
                                width: 1000,
                                height: 377
                            })
                        })
                    }, index);
                }) : _.range(2).map(function(index) {
                    /*#__PURE__*/ return _jsx("div", {
                        className: style.skeleton_card,
                        children: /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            width: "100%",
                            height: 210
                        })
                    }, index);
                })
            })
        })
    }));
}
function CurationCarousel() {
    var imageHost = "https://home-backoffice.tqm-app.com";
    var contentHost = "https://home-legacy.tqm-app.com/api";
    var ref = useState(), bannerList = ref[0], setBannerList = ref[1];
    var fetcher = function(url) {
        return axios.get(url, {
            withCredentials: true
        }).then(function(res) {
            return res.data;
        });
    };
    var ref2 = useSWR("".concat(contentHost, "/products/banners"), fetcher, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), banners = ref2.data, error = ref2.error;
    useEffect(function() {
        if (!banners) return;
        var _mappedBanner = banners.map(function(banner) {
            return _objectSpread({}, banner, {
                image: imageHost + banner.image
            });
        });
        setBannerList(_mappedBanner);
    }, [
        banners
    ]);
    return(/*#__PURE__*/ _jsx(CurationBannerCarousel, {
        carouselItem: bannerList
    }));
};

// EXTERNAL MODULE: ./components/home/event-carousel/event_carousel.module.css
var event_carousel_module = __webpack_require__(35991);
var event_carousel_module_default = /*#__PURE__*/__webpack_require__.n(event_carousel_module);
;// CONCATENATED MODULE: ./components/home/event-carousel/event_carousel.js







function EventCard(eventObj) {
    var ref = (0,react.useState)(eventObj.eventObj), event = ref[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (event_carousel_module_default()).event_card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (event_carousel_module_default()).event_card__cover,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    layout: "fill",
                    objectFit: "cover",
                    src: event.thumbnail
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (event_carousel_module_default()).event_card__detail,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (event_carousel_module_default()).event_card__detail__title,
                        children: event.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (event_carousel_module_default()).event_card__detail__date,
                        children: event.date
                    })
                ]
            })
        ]
    }));
}
function EventCarousel() {
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)([]), eventList = ref1[0], setEventList = ref1[1];
    var eventCarouselRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _eventList = content_data/* eventCardItems */.Nr;
        setEventList(_eventList);
    }, []);
    var arrow = function(param) {
        var type = param.type, onClick = param.onClick, isEdge = param.isEdge;
        var pointer = type === index_es/* consts.PREV */.v.PREV ? "/assets/icon-svg/arr-left-carousel.svg" : "/assets/icon-svg/arr-right-carousel.svg";
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (event_carousel_module_default()).arrow,
            onClick: onClick,
            disabled: isEdge,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: pointer,
                width: 7,
                height: 12,
                layout: "fixed"
            })
        }));
    };
    var onItemClickHandler = function(e, url) {
        router.push(url);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: eventList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (event_carousel_module_default()).events_carousel_wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                itemsToShow: 3,
                showArrows: false,
                pagination: false,
                // renderArrow={arrow}
                ref: function(ref) {
                    return eventCarouselRef = ref;
                },
                children: eventList.map(function(event, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: (event_carousel_module_default()).event_card_wrapper,
                        onClick: function(e) {
                            onItemClickHandler(e, event.url);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
                            eventObj: event
                        })
                    }, index);
                })
            })
        })
    }));
};

// EXTERNAL MODULE: ./pages/home/style.module.css
var style_module = __webpack_require__(55898);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js + 1 modules
var esm = __webpack_require__(40802);
;// CONCATENATED MODULE: ./pages/home/index.js



/* Component Import */ 








/* CSS Import */ 

function Home() {
    esm/* setTag */.YA("page", "home");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "ค้นหา ประกันบ้าน ประกันอัคคีภัย ครอบคลุมไฟไหม้ น้ำท่วม โจรปล้น - บริษัท TQM"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (style_module_default()).main_cta_section,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).main_cta_background
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).main_cta_container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceEase, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).partner_insurer_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).partner_insurer_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerInsurerCarousel, {})
                })
            }),
             false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).product_carousel_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).product_carousel_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).product_carousel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarouselContainer, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).article_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (style_module_default()).article_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "เรื่องบ้านน่ารู้"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).article,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCarouselContainer, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).buy_step_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).step_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuySteps, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).testimonial_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).testimonial_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).testimonial,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).title_wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "เสียงจากลูกค้า TQM HOME"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).customers_testimonial,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).carousel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCarousel, {})
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).partner_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (style_module_default()).partner_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "สิทธิพิเศษสำหรับคุณ"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerDeals, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (style_module_default()).event_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (style_module_default()).event_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "ข่าว กิจกรรม ประชาสัมพันธ์"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCarousel, {})
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 26684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"article-carousel_sr-only__db9Gi","!static":"article-carousel___static__zTJdr","static":"article-carousel_static__aLqKB","fixed":"article-carousel_fixed__4mVPf","absolute":"article-carousel_absolute___97Vc","relative":"article-carousel_relative__MbDPL","right-4":"article-carousel_right-4__ghbZw","top-6":"article-carousel_top-6__XKprF","z-40":"article-carousel_z-40__qp91b","z-0":"article-carousel_z-0__VviVk","m-auto":"article-carousel_m-auto__RJtw0","my-1":"article-carousel_my-1__bcZ5j","mt-4":"article-carousel_mt-4__ONRl7","mt-0":"article-carousel_mt-0__zHesS","mt-16":"article-carousel_mt-16__2jvok","block":"article-carousel_block__4gKp_","inline-block":"article-carousel_inline-block__1W5S0","inline":"article-carousel_inline___AEbr","flex":"article-carousel_flex__ZRjvh","table":"article-carousel_table__KR6Wk","contents":"article-carousel_contents__4zSdA","hidden":"article-carousel_hidden__FLrmD","h-screen":"article-carousel_h-screen__MRC1G","h-6":"article-carousel_h-6__TDlpr","min-h-[400px]":"article-carousel_min-h-__400px____MwZV2","min-h-screen":"article-carousel_min-h-screen__wNIg4","w-full":"article-carousel_w-full__szOFD","w-6":"article-carousel_w-6__4rl_u","origin-top":"article-carousel_origin-top__Myzbx","-translate-y-1":"article-carousel_-translate-y-1__C5_8j","translate-y-0":"article-carousel_translate-y-0__wQZks","scale-95":"article-carousel_scale-95__ZaOyr","scale-100":"article-carousel_scale-100__8O4E_","scale-y-95":"article-carousel_scale-y-95__bhXYW","scale-y-100":"article-carousel_scale-y-100__L_5hW","transform":"article-carousel_transform__iL02O","resize":"article-carousel_resize__pkKY_","items-center":"article-carousel_items-center__QcFVs","justify-between":"article-carousel_justify-between___LzP3","gap-2":"article-carousel_gap-2__aZvbI","rounded":"article-carousel_rounded__5SmmB","rounded-t-xl":"article-carousel_rounded-t-xl__tw022","bg-white":"article-carousel_bg-white__moUg7","bg-gradient-to-b":"article-carousel_bg-gradient-to-b__hAtMM","from-[#fff]":"article-carousel_from-____fff____ONwcW","to-[#E6E6E6]":"article-carousel_to-____E6E6E6____tglw9","p-3":"article-carousel_p-3__9X8sY","p-1":"article-carousel_p-1__xn1jV","p-4":"article-carousel_p-4__brB3C","px-4":"article-carousel_px-4__KCJZ2","py-6":"article-carousel_py-6__cIzQ5","pb-4":"article-carousel_pb-4___i5pK","pr-7":"article-carousel_pr-7__rwhx5","pb-[216px]":"article-carousel_pb-__216px____bat04","text-center":"article-carousel_text-center__3KJpD","text-right":"article-carousel_text-right__IgLfi","align-top":"article-carousel_align-top__d0K3e","align-middle":"article-carousel_align-middle__OeUUP","text-xs":"article-carousel_text-xs__6KOo1","text-lg":"article-carousel_text-lg__ctiGx","text-input2":"article-carousel_text-input2__quyJW","text-headline7":"article-carousel_text-headline7__zXweh","text-button-small":"article-carousel_text-button-small__qGbre","font-bold":"article-carousel_font-bold__Xe_gl","font-semibold":"article-carousel_font-semibold__b84f8","text-tqm-red-primary":"article-carousel_text-tqm-red-primary__2Zhgn","text-white":"article-carousel_text-white__doNf0","text-[#02A989]":"article-carousel_text-____02A989____sph09","text-black":"article-carousel_text-black__k6bY1","text-gray-900":"article-carousel_text-gray-900__AwhWh","!text-light-blue-500":"article-carousel___text-light-blue-500__2Fuw4","underline":"article-carousel_underline__ZKlOP","opacity-0":"article-carousel_opacity-0__RZIUE","opacity-100":"article-carousel_opacity-100__jkcYc","shadow-xs":"article-carousel_shadow-xs__GXagN","filter":"article-carousel_filter__Gnsio","transition":"article-carousel_transition___bWsM","transition-all":"article-carousel_transition-all__09fb5","duration-100":"article-carousel_duration-100__b_4qx","duration-75":"article-carousel_duration-75__IQnos","duration-200":"article-carousel_duration-200__z0dK6","duration-150":"article-carousel_duration-150__se_Sg","duration-300":"article-carousel_duration-300__5SBDh","ease-out":"article-carousel_ease-out__69grM","ease-in":"article-carousel_ease-in__ylfDv","articles_carousel_container":"article-carousel_articles_carousel_container__difZm","article_card":"article-carousel_article_card__KR9ZJ","image_wrapper":"article-carousel_image_wrapper__xEGj1","content":"article-carousel_content__Ru0ym","!articles_carousel_container":"article-carousel___articles_carousel_container__Y7zae","!article_card":"article-carousel___article_card__HYHUM","!content":"article-carousel___content__Klz2I","tablet:block":"article-carousel_tablet__block__obsR1","tablet:max-w-[200px]":"article-carousel_tablet__max-w-__200px____cAvrx","tablet:p-6":"article-carousel_tablet__p-6__8i15s","tablet:text-xl":"article-carousel_tablet__text-xl__dNrr9"};

/***/ }),

/***/ 5517:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"buy_step_sr-only__u_Hlx","!static":"buy_step___static__kSjC9","static":"buy_step_static__pKwnU","fixed":"buy_step_fixed__XERym","absolute":"buy_step_absolute__FqWRd","relative":"buy_step_relative__zzdF4","right-4":"buy_step_right-4__PqWLi","top-6":"buy_step_top-6__g7_Sj","z-40":"buy_step_z-40__RxRvs","z-0":"buy_step_z-0__XvQqL","m-auto":"buy_step_m-auto__FGLaK","my-1":"buy_step_my-1___yuWW","mt-4":"buy_step_mt-4__2IjmJ","mt-0":"buy_step_mt-0__GF2EG","mt-16":"buy_step_mt-16__uzfcG","block":"buy_step_block__WvxL6","inline-block":"buy_step_inline-block__tnRAX","inline":"buy_step_inline__TDyUg","flex":"buy_step_flex__vD3yn","table":"buy_step_table__GXozR","contents":"buy_step_contents__HSDYX","hidden":"buy_step_hidden__kR8Ri","h-screen":"buy_step_h-screen__0c6OD","h-6":"buy_step_h-6__ElZhB","min-h-[400px]":"buy_step_min-h-__400px____TX3vb","min-h-screen":"buy_step_min-h-screen__H_3XA","w-full":"buy_step_w-full__h7jSa","w-6":"buy_step_w-6__aGiVb","origin-top":"buy_step_origin-top__9qZSS","-translate-y-1":"buy_step_-translate-y-1__iEnqH","translate-y-0":"buy_step_translate-y-0__M44Qn","scale-95":"buy_step_scale-95__a_KXj","scale-100":"buy_step_scale-100__fvXsq","scale-y-95":"buy_step_scale-y-95__BhbFR","scale-y-100":"buy_step_scale-y-100__TGTjX","transform":"buy_step_transform__2jl76","resize":"buy_step_resize__AK6j4","items-center":"buy_step_items-center__lrFXm","justify-between":"buy_step_justify-between__Pd_yz","gap-2":"buy_step_gap-2__dN_ko","rounded":"buy_step_rounded__19LIw","rounded-t-xl":"buy_step_rounded-t-xl__Cf2T6","bg-white":"buy_step_bg-white__GhNAW","bg-gradient-to-b":"buy_step_bg-gradient-to-b__rpIGB","from-[#fff]":"buy_step_from-____fff____spgIx","to-[#E6E6E6]":"buy_step_to-____E6E6E6____rN284","p-3":"buy_step_p-3__iHqVC","p-1":"buy_step_p-1__py5Me","p-4":"buy_step_p-4__1hGNs","px-4":"buy_step_px-4__0nQmw","py-6":"buy_step_py-6__TPN9l","pb-4":"buy_step_pb-4__rgR3l","pr-7":"buy_step_pr-7__ZIEAe","pb-[216px]":"buy_step_pb-__216px____V6ZbJ","text-center":"buy_step_text-center__6SnFf","text-right":"buy_step_text-right__n2yGS","align-top":"buy_step_align-top__3_NKj","align-middle":"buy_step_align-middle__vdh2_","text-xs":"buy_step_text-xs___lWg7","text-lg":"buy_step_text-lg__gQfYd","text-input2":"buy_step_text-input2__J3wi5","text-headline7":"buy_step_text-headline7__lb5NI","text-button-small":"buy_step_text-button-small__dAZHd","font-bold":"buy_step_font-bold__DGaSS","font-semibold":"buy_step_font-semibold___wjx6","text-tqm-red-primary":"buy_step_text-tqm-red-primary__XMXTo","text-white":"buy_step_text-white__4RB88","text-[#02A989]":"buy_step_text-____02A989____E0ziB","text-black":"buy_step_text-black__U2Tm7","text-gray-900":"buy_step_text-gray-900__DXQtQ","!text-light-blue-500":"buy_step___text-light-blue-500__8gONs","underline":"buy_step_underline__Jo_Po","opacity-0":"buy_step_opacity-0__gj14f","opacity-100":"buy_step_opacity-100__wNyzy","shadow-xs":"buy_step_shadow-xs____N_2","filter":"buy_step_filter__KHeN8","transition":"buy_step_transition__jusvU","transition-all":"buy_step_transition-all__X3Ppd","duration-100":"buy_step_duration-100__RxFIP","duration-75":"buy_step_duration-75__ZYezl","duration-200":"buy_step_duration-200__Jgz7j","duration-150":"buy_step_duration-150__Phn_m","duration-300":"buy_step_duration-300__hTmT9","ease-out":"buy_step_ease-out___mBCn","ease-in":"buy_step_ease-in___9sAA","buy_steps":"buy_step_buy_steps__cBHdK","title":"buy_step_title__rkFyJ","buy_step_items":"buy_step_buy_step_items__rMEDx","buy_step_items_container":"buy_step_buy_step_items_container__eL1jK","buy_step":"buy_step_buy_step__iDWZ6","buy_step_heading":"buy_step_buy_step_heading__FVTFo","buy_step_details_title":"buy_step_buy_step_details_title__Z_e6B","buy_step_details_description":"buy_step_buy_step_details_description__lz77a","tablet:block":"buy_step_tablet__block__iMfjf","tablet:max-w-[200px]":"buy_step_tablet__max-w-__200px____Xz_Kq","tablet:p-6":"buy_step_tablet__p-6__S5KiV","tablet:text-xl":"buy_step_tablet__text-xl__bNASG"};

/***/ }),

/***/ 35991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"event_card":"event_carousel_event_card__WZ_5z","event_card__cover":"event_carousel_event_card__cover__9kh0O","event_card__detail":"event_carousel_event_card__detail__8xSZ6","event_card__detail__title":"event_carousel_event_card__detail__title__dfRpW","event_card__detail__date":"event_carousel_event_card__detail__date__c8RXW","sr-only":"event_carousel_sr-only__Cu3je","!static":"event_carousel___static__6dnVR","static":"event_carousel_static__w5Y7g","fixed":"event_carousel_fixed__wiSYT","absolute":"event_carousel_absolute__XsIIj","relative":"event_carousel_relative__wx5Oz","right-4":"event_carousel_right-4__EdtwO","top-6":"event_carousel_top-6__g9Y6g","z-40":"event_carousel_z-40__9GqFh","z-0":"event_carousel_z-0__XxJaI","m-auto":"event_carousel_m-auto__7IzMh","my-1":"event_carousel_my-1__9lzbB","mt-4":"event_carousel_mt-4__DYt0h","mt-0":"event_carousel_mt-0__IwG12","mt-16":"event_carousel_mt-16__9Z4TP","block":"event_carousel_block__DByDa","inline-block":"event_carousel_inline-block__6XVtB","inline":"event_carousel_inline__wvnNW","flex":"event_carousel_flex__MXbNa","table":"event_carousel_table__coFwF","contents":"event_carousel_contents__jAQA7","hidden":"event_carousel_hidden__Mn5n_","h-screen":"event_carousel_h-screen__e0InA","h-6":"event_carousel_h-6__r8w9L","min-h-[400px]":"event_carousel_min-h-__400px____AHcGv","min-h-screen":"event_carousel_min-h-screen__ZMOqg","w-full":"event_carousel_w-full__GFReK","w-6":"event_carousel_w-6___5yb1","origin-top":"event_carousel_origin-top__ra8GE","-translate-y-1":"event_carousel_-translate-y-1__l5_jY","translate-y-0":"event_carousel_translate-y-0__z7Nq8","scale-95":"event_carousel_scale-95__X4yef","scale-100":"event_carousel_scale-100__27uft","scale-y-95":"event_carousel_scale-y-95__UF_tn","scale-y-100":"event_carousel_scale-y-100__M1ICf","transform":"event_carousel_transform__uY1P4","resize":"event_carousel_resize__QIpwr","items-center":"event_carousel_items-center__tlpQ1","justify-between":"event_carousel_justify-between__gW43C","gap-2":"event_carousel_gap-2__fTEmO","rounded":"event_carousel_rounded___jrXg","rounded-t-xl":"event_carousel_rounded-t-xl__EGXkb","bg-white":"event_carousel_bg-white__yxhjj","bg-gradient-to-b":"event_carousel_bg-gradient-to-b__jOy4d","from-[#fff]":"event_carousel_from-____fff____WNMcQ","to-[#E6E6E6]":"event_carousel_to-____E6E6E6____YQZL_","p-3":"event_carousel_p-3__sK0xo","p-1":"event_carousel_p-1__bfMAi","p-4":"event_carousel_p-4__NIKqK","px-4":"event_carousel_px-4__2TEkF","py-6":"event_carousel_py-6__NRVdX","pb-4":"event_carousel_pb-4__7RpTU","pr-7":"event_carousel_pr-7__X5L8t","pb-[216px]":"event_carousel_pb-__216px____QLHo6","text-center":"event_carousel_text-center__ioAbm","text-right":"event_carousel_text-right__yDGW6","align-top":"event_carousel_align-top__HNIK8","align-middle":"event_carousel_align-middle__Qf6IP","text-xs":"event_carousel_text-xs__Yj_4e","text-lg":"event_carousel_text-lg__b_4lJ","text-input2":"event_carousel_text-input2__jZxuN","text-headline7":"event_carousel_text-headline7__hMai7","text-button-small":"event_carousel_text-button-small__yTGeT","font-bold":"event_carousel_font-bold__ZzqHU","font-semibold":"event_carousel_font-semibold__F43p0","text-tqm-red-primary":"event_carousel_text-tqm-red-primary__AjjC2","text-white":"event_carousel_text-white__lNY65","text-[#02A989]":"event_carousel_text-____02A989____A0Noz","text-black":"event_carousel_text-black__QJBOt","text-gray-900":"event_carousel_text-gray-900__3HZAZ","!text-light-blue-500":"event_carousel___text-light-blue-500__F2G_7","underline":"event_carousel_underline__PP_NH","opacity-0":"event_carousel_opacity-0__yiw_a","opacity-100":"event_carousel_opacity-100__BTdQj","shadow-xs":"event_carousel_shadow-xs__uh1bU","filter":"event_carousel_filter__O1Vu0","transition":"event_carousel_transition__02H_g","transition-all":"event_carousel_transition-all__UDXmO","duration-100":"event_carousel_duration-100__olAfK","duration-75":"event_carousel_duration-75__d8PgY","duration-200":"event_carousel_duration-200__cGkzY","duration-150":"event_carousel_duration-150__asy3x","duration-300":"event_carousel_duration-300__ntmI4","ease-out":"event_carousel_ease-out__Qag5j","ease-in":"event_carousel_ease-in__AcrJ7","tablet:block":"event_carousel_tablet__block__W_mWg","tablet:max-w-[200px]":"event_carousel_tablet__max-w-__200px____bCOHw","tablet:p-6":"event_carousel_tablet__p-6__CTen4","tablet:text-xl":"event_carousel_tablet__text-xl__s0TnC"};

/***/ }),

/***/ 70017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"insurance_ease_sr-only__1kz5U","!static":"insurance_ease___static__63Kqb","static":"insurance_ease_static__NwjZG","fixed":"insurance_ease_fixed__BPsz8","absolute":"insurance_ease_absolute__3V_DM","relative":"insurance_ease_relative__Iw4NJ","right-4":"insurance_ease_right-4__2zDB_","top-6":"insurance_ease_top-6__teSh_","z-40":"insurance_ease_z-40__LeAKU","z-0":"insurance_ease_z-0__STDZ1","m-auto":"insurance_ease_m-auto__FhSMs","my-1":"insurance_ease_my-1__32KOc","mt-4":"insurance_ease_mt-4__MWWtT","mt-0":"insurance_ease_mt-0__mBr8n","mt-16":"insurance_ease_mt-16__hijcm","block":"insurance_ease_block__w6j1W","inline-block":"insurance_ease_inline-block__4bTs0","inline":"insurance_ease_inline__V_SXT","flex":"insurance_ease_flex__gyjei","table":"insurance_ease_table__qu8fL","contents":"insurance_ease_contents__Ept0O","hidden":"insurance_ease_hidden__OsxsJ","h-screen":"insurance_ease_h-screen__H28JU","h-6":"insurance_ease_h-6__Pp1de","min-h-[400px]":"insurance_ease_min-h-__400px____H4AFV","min-h-screen":"insurance_ease_min-h-screen__bLPoZ","w-full":"insurance_ease_w-full__1pLSb","w-6":"insurance_ease_w-6__aFmOr","origin-top":"insurance_ease_origin-top__jAOfT","-translate-y-1":"insurance_ease_-translate-y-1__NcZzi","translate-y-0":"insurance_ease_translate-y-0__XP1wo","scale-95":"insurance_ease_scale-95__qDjSW","scale-100":"insurance_ease_scale-100__Ru6gX","scale-y-95":"insurance_ease_scale-y-95__7eV2p","scale-y-100":"insurance_ease_scale-y-100__eBOqm","transform":"insurance_ease_transform__OO98g","resize":"insurance_ease_resize__YwiG8","items-center":"insurance_ease_items-center__DNAor","justify-between":"insurance_ease_justify-between__AnLRT","gap-2":"insurance_ease_gap-2__jmlRR","rounded":"insurance_ease_rounded__cbRl5","rounded-t-xl":"insurance_ease_rounded-t-xl__3H_ce","bg-white":"insurance_ease_bg-white__9_Nkv","bg-gradient-to-b":"insurance_ease_bg-gradient-to-b__a7Cgk","from-[#fff]":"insurance_ease_from-____fff____VC6iN","to-[#E6E6E6]":"insurance_ease_to-____E6E6E6____64qZZ","p-3":"insurance_ease_p-3__LSv7N","p-1":"insurance_ease_p-1__ghQjP","p-4":"insurance_ease_p-4__QSKPR","px-4":"insurance_ease_px-4__fgIy2","py-6":"insurance_ease_py-6__INnSE","pb-4":"insurance_ease_pb-4__h8mj2","pr-7":"insurance_ease_pr-7__0gvpC","pb-[216px]":"insurance_ease_pb-__216px____ylVOt","text-center":"insurance_ease_text-center__UbGdk","text-right":"insurance_ease_text-right__SKafh","align-top":"insurance_ease_align-top__WQUWL","align-middle":"insurance_ease_align-middle__pxBrW","text-xs":"insurance_ease_text-xs__YkQnh","text-lg":"insurance_ease_text-lg___kQO6","text-input2":"insurance_ease_text-input2__NG2mg","text-headline7":"insurance_ease_text-headline7__pS0aD","text-button-small":"insurance_ease_text-button-small__W8UUr","font-bold":"insurance_ease_font-bold__RwnnE","font-semibold":"insurance_ease_font-semibold__5_7hu","text-tqm-red-primary":"insurance_ease_text-tqm-red-primary__VU55D","text-white":"insurance_ease_text-white__rZG25","text-[#02A989]":"insurance_ease_text-____02A989____UiiL2","text-black":"insurance_ease_text-black__RxY5s","text-gray-900":"insurance_ease_text-gray-900__bWwy4","!text-light-blue-500":"insurance_ease___text-light-blue-500__HZ1kj","underline":"insurance_ease_underline__JdnWo","opacity-0":"insurance_ease_opacity-0__1cS1_","opacity-100":"insurance_ease_opacity-100___PGfo","shadow-xs":"insurance_ease_shadow-xs__YiPIY","filter":"insurance_ease_filter__7rpm6","transition":"insurance_ease_transition__AhfBN","transition-all":"insurance_ease_transition-all__hsOqW","duration-100":"insurance_ease_duration-100__8eEvb","duration-75":"insurance_ease_duration-75__OjKop","duration-200":"insurance_ease_duration-200__VJpun","duration-150":"insurance_ease_duration-150__sSa5G","duration-300":"insurance_ease_duration-300__kdJbg","ease-out":"insurance_ease_ease-out__9crt4","ease-in":"insurance_ease_ease-in__O0LZ0","insurance_ease":"insurance_ease_insurance_ease__c7yaL","insurance_ease_cta_container":"insurance_ease_insurance_ease_cta_container__lJ2_b","title":"insurance_ease_title__rTcTE","incident_carousel":"insurance_ease_incident_carousel__RNjbw","ease_items":"insurance_ease_ease_items__JwfyX","ease_items_cointainer":"insurance_ease_ease_items_cointainer__6gkkh","ease_item":"insurance_ease_ease_item__f43Ad","ease_icon":"insurance_ease_ease_icon__uLfpa","ease_btn_group":"insurance_ease_ease_btn_group__516t8","ease_main_cta":"insurance_ease_ease_main_cta__5apBy","ease_drop_lead":"insurance_ease_ease_drop_lead__8NnQ4","bear_mascot":"insurance_ease_bear_mascot__7TUde","tablet:block":"insurance_ease_tablet__block__tp2F8","tablet:max-w-[200px]":"insurance_ease_tablet__max-w-__200px____sSv85","tablet:p-6":"insurance_ease_tablet__p-6__QZ3ad","tablet:text-xl":"insurance_ease_tablet__text-xl__k1zVR"};

/***/ }),

/***/ 89556:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"partner_deals_sr-only__Jk3kl","!static":"partner_deals___static__OAwjJ","static":"partner_deals_static__kT0mX","fixed":"partner_deals_fixed__lJJ_4","absolute":"partner_deals_absolute__tvX_K","relative":"partner_deals_relative__5Th0K","right-4":"partner_deals_right-4__WL58g","top-6":"partner_deals_top-6__G_4qD","z-40":"partner_deals_z-40__S8AKj","z-0":"partner_deals_z-0__gsWvW","m-auto":"partner_deals_m-auto__eUa_J","my-1":"partner_deals_my-1__atCFV","mt-4":"partner_deals_mt-4__xSenM","mt-0":"partner_deals_mt-0___Ga9_","mt-16":"partner_deals_mt-16__agMPC","block":"partner_deals_block__NWqrc","inline-block":"partner_deals_inline-block__z20_D","inline":"partner_deals_inline__Y2cWq","flex":"partner_deals_flex__F6fHh","table":"partner_deals_table__QNNsu","contents":"partner_deals_contents__TcByr","hidden":"partner_deals_hidden__MEWI4","h-screen":"partner_deals_h-screen__9Clhw","h-6":"partner_deals_h-6__g8Jfg","min-h-[400px]":"partner_deals_min-h-__400px____P6V1L","min-h-screen":"partner_deals_min-h-screen__lK9NY","w-full":"partner_deals_w-full__G5EWZ","w-6":"partner_deals_w-6__t9s0m","origin-top":"partner_deals_origin-top__0es2L","-translate-y-1":"partner_deals_-translate-y-1__uf8dx","translate-y-0":"partner_deals_translate-y-0__WPPmQ","scale-95":"partner_deals_scale-95__VmEYH","scale-100":"partner_deals_scale-100__4sSkH","scale-y-95":"partner_deals_scale-y-95__r4t_l","scale-y-100":"partner_deals_scale-y-100__Q4VXa","transform":"partner_deals_transform__xrGfQ","resize":"partner_deals_resize__uENjS","items-center":"partner_deals_items-center__gC1qu","justify-between":"partner_deals_justify-between__qoiGX","gap-2":"partner_deals_gap-2__DD_eo","rounded":"partner_deals_rounded__MTayl","rounded-t-xl":"partner_deals_rounded-t-xl__xexwF","bg-white":"partner_deals_bg-white__RCv5Y","bg-gradient-to-b":"partner_deals_bg-gradient-to-b__zSrqf","from-[#fff]":"partner_deals_from-____fff____gaRl_","to-[#E6E6E6]":"partner_deals_to-____E6E6E6____ts27f","p-3":"partner_deals_p-3__utq5I","p-1":"partner_deals_p-1__arOhJ","p-4":"partner_deals_p-4__tr3M9","px-4":"partner_deals_px-4__b79sp","py-6":"partner_deals_py-6__dXly9","pb-4":"partner_deals_pb-4__QxEvX","pr-7":"partner_deals_pr-7__4KQKF","pb-[216px]":"partner_deals_pb-__216px____kse_w","text-center":"partner_deals_text-center__VZ8rl","text-right":"partner_deals_text-right__lT_SV","align-top":"partner_deals_align-top__pIEli","align-middle":"partner_deals_align-middle__gkByG","text-xs":"partner_deals_text-xs__XjqhG","text-lg":"partner_deals_text-lg__3meT3","text-input2":"partner_deals_text-input2__71YCW","text-headline7":"partner_deals_text-headline7__WFe4H","text-button-small":"partner_deals_text-button-small__GdeYF","font-bold":"partner_deals_font-bold__KWQxP","font-semibold":"partner_deals_font-semibold__9ckJP","text-tqm-red-primary":"partner_deals_text-tqm-red-primary__9FDRd","text-white":"partner_deals_text-white__YaaP_","text-[#02A989]":"partner_deals_text-____02A989____dq6LY","text-black":"partner_deals_text-black__Zfi0H","text-gray-900":"partner_deals_text-gray-900__D00TC","!text-light-blue-500":"partner_deals___text-light-blue-500__Kgjr_","underline":"partner_deals_underline__Fz3eu","opacity-0":"partner_deals_opacity-0__3MWLw","opacity-100":"partner_deals_opacity-100__dP47G","shadow-xs":"partner_deals_shadow-xs__bee7D","filter":"partner_deals_filter__Wv2HA","transition":"partner_deals_transition__H8oSx","transition-all":"partner_deals_transition-all__ayZxw","duration-100":"partner_deals_duration-100__5OHCy","duration-75":"partner_deals_duration-75__aY8BX","duration-200":"partner_deals_duration-200__uf6im","duration-150":"partner_deals_duration-150__Y5K_b","duration-300":"partner_deals_duration-300__kZSC3","ease-out":"partner_deals_ease-out__ZEn__","ease-in":"partner_deals_ease-in__LrlNH","partner_deals":"partner_deals_partner_deals___BG1g","partner_card":"partner_deals_partner_card__B2vXL","partner_image_wrapper":"partner_deals_partner_image_wrapper__9Ef6i","tablet:block":"partner_deals_tablet__block__fA90k","tablet:max-w-[200px]":"partner_deals_tablet__max-w-__200px____9gtt7","tablet:p-6":"partner_deals_tablet__p-6__Sb9yQ","tablet:text-xl":"partner_deals_tablet__text-xl__qxl00"};

/***/ }),

/***/ 31751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"partner_insurer_carousel_sr-only__1egWP","!static":"partner_insurer_carousel___static__v33xB","static":"partner_insurer_carousel_static__JTfh0","fixed":"partner_insurer_carousel_fixed__itaTK","absolute":"partner_insurer_carousel_absolute__dhcVr","relative":"partner_insurer_carousel_relative__OlqEU","right-4":"partner_insurer_carousel_right-4__OxQRz","top-6":"partner_insurer_carousel_top-6__Xd5kn","z-40":"partner_insurer_carousel_z-40__d5GzZ","z-0":"partner_insurer_carousel_z-0__poZ0U","m-auto":"partner_insurer_carousel_m-auto__B31_m","my-1":"partner_insurer_carousel_my-1__G6pEG","mt-4":"partner_insurer_carousel_mt-4__21Q3b","mt-0":"partner_insurer_carousel_mt-0__57SKB","mt-16":"partner_insurer_carousel_mt-16__mI6qz","block":"partner_insurer_carousel_block__n1ZK8","inline-block":"partner_insurer_carousel_inline-block__f17re","inline":"partner_insurer_carousel_inline__X59WB","flex":"partner_insurer_carousel_flex__gORFt","table":"partner_insurer_carousel_table__MnP_2","contents":"partner_insurer_carousel_contents__WqaRU","hidden":"partner_insurer_carousel_hidden__fMz7D","h-screen":"partner_insurer_carousel_h-screen__uOeAk","h-6":"partner_insurer_carousel_h-6__fwuSY","min-h-[400px]":"partner_insurer_carousel_min-h-__400px____i8X4c","min-h-screen":"partner_insurer_carousel_min-h-screen__Ya3aC","w-full":"partner_insurer_carousel_w-full__8K4Cm","w-6":"partner_insurer_carousel_w-6__8q8dk","origin-top":"partner_insurer_carousel_origin-top__Di_ku","-translate-y-1":"partner_insurer_carousel_-translate-y-1__cE805","translate-y-0":"partner_insurer_carousel_translate-y-0__G_6QY","scale-95":"partner_insurer_carousel_scale-95__DiMIX","scale-100":"partner_insurer_carousel_scale-100__w5u4A","scale-y-95":"partner_insurer_carousel_scale-y-95__pLCsa","scale-y-100":"partner_insurer_carousel_scale-y-100__0m8j_","transform":"partner_insurer_carousel_transform__J7hiR","resize":"partner_insurer_carousel_resize__edUBx","items-center":"partner_insurer_carousel_items-center__wgoxQ","justify-between":"partner_insurer_carousel_justify-between__p1D8a","gap-2":"partner_insurer_carousel_gap-2__Blbh4","rounded":"partner_insurer_carousel_rounded__UZ5tI","rounded-t-xl":"partner_insurer_carousel_rounded-t-xl__oKYy8","bg-white":"partner_insurer_carousel_bg-white__J3Fm5","bg-gradient-to-b":"partner_insurer_carousel_bg-gradient-to-b___F1pt","from-[#fff]":"partner_insurer_carousel_from-____fff____Q7B5G","to-[#E6E6E6]":"partner_insurer_carousel_to-____E6E6E6____PhVeg","p-3":"partner_insurer_carousel_p-3__rGCp8","p-1":"partner_insurer_carousel_p-1__PIcVo","p-4":"partner_insurer_carousel_p-4__6_zuG","px-4":"partner_insurer_carousel_px-4__zSCAt","py-6":"partner_insurer_carousel_py-6__Lqhsj","pb-4":"partner_insurer_carousel_pb-4__2cBLV","pr-7":"partner_insurer_carousel_pr-7__lQ8hf","pb-[216px]":"partner_insurer_carousel_pb-__216px____qSuyw","text-center":"partner_insurer_carousel_text-center__uKFBC","text-right":"partner_insurer_carousel_text-right__drMnY","align-top":"partner_insurer_carousel_align-top__QNt4H","align-middle":"partner_insurer_carousel_align-middle___9GbP","text-xs":"partner_insurer_carousel_text-xs__J08P_","text-lg":"partner_insurer_carousel_text-lg__LVfZR","text-input2":"partner_insurer_carousel_text-input2__UcFch","text-headline7":"partner_insurer_carousel_text-headline7__mDgbo","text-button-small":"partner_insurer_carousel_text-button-small__KhmBm","font-bold":"partner_insurer_carousel_font-bold__NahUW","font-semibold":"partner_insurer_carousel_font-semibold__CEbU6","text-tqm-red-primary":"partner_insurer_carousel_text-tqm-red-primary__lT6oG","text-white":"partner_insurer_carousel_text-white__6hfPE","text-[#02A989]":"partner_insurer_carousel_text-____02A989____nbzPL","text-black":"partner_insurer_carousel_text-black__OoBnp","text-gray-900":"partner_insurer_carousel_text-gray-900__DIUzG","!text-light-blue-500":"partner_insurer_carousel___text-light-blue-500__oDEEB","underline":"partner_insurer_carousel_underline__65xFK","opacity-0":"partner_insurer_carousel_opacity-0__Drph4","opacity-100":"partner_insurer_carousel_opacity-100__6JhzI","shadow-xs":"partner_insurer_carousel_shadow-xs__ODd1b","filter":"partner_insurer_carousel_filter__AhBL5","transition":"partner_insurer_carousel_transition__d7cS6","transition-all":"partner_insurer_carousel_transition-all__62E8D","duration-100":"partner_insurer_carousel_duration-100__Kc6Pw","duration-75":"partner_insurer_carousel_duration-75__2V5yO","duration-200":"partner_insurer_carousel_duration-200__KjLaI","duration-150":"partner_insurer_carousel_duration-150__inNix","duration-300":"partner_insurer_carousel_duration-300__dZxFa","ease-out":"partner_insurer_carousel_ease-out__ZBAmj","ease-in":"partner_insurer_carousel_ease-in__g2ODy","partner_insurer_carousel":"partner_insurer_carousel_partner_insurer_carousel__dJmon","title":"partner_insurer_carousel_title__wq3eT","carousel_slider_container":"partner_insurer_carousel_carousel_slider_container__fwUkn","partner_card":"partner_insurer_carousel_partner_card__DWFN9","tablet:block":"partner_insurer_carousel_tablet__block__faSQb","tablet:max-w-[200px]":"partner_insurer_carousel_tablet__max-w-__200px____UtKpF","tablet:p-6":"partner_insurer_carousel_tablet__p-6__Jhhzv","tablet:text-xl":"partner_insurer_carousel_tablet__text-xl____paW"};

/***/ }),

/***/ 72021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"product_carousel_sr-only__QfJpF","!static":"product_carousel___static__khBpU","static":"product_carousel_static__UhMEu","fixed":"product_carousel_fixed__Rep2d","absolute":"product_carousel_absolute__6eO7L","relative":"product_carousel_relative__DURb7","right-4":"product_carousel_right-4__2AHLQ","top-6":"product_carousel_top-6__3Nh92","z-40":"product_carousel_z-40__F5Z6q","z-0":"product_carousel_z-0__Plrvc","m-auto":"product_carousel_m-auto__adBAO","my-1":"product_carousel_my-1__grN00","mt-4":"product_carousel_mt-4__aZoHj","mt-0":"product_carousel_mt-0__p2dFe","mt-16":"product_carousel_mt-16__6NJVJ","block":"product_carousel_block__SEYQy","inline-block":"product_carousel_inline-block__d2EfY","inline":"product_carousel_inline__TTX_d","flex":"product_carousel_flex__0mcjs","table":"product_carousel_table__t8Qlu","contents":"product_carousel_contents__X5Kug","hidden":"product_carousel_hidden__K1Laq","h-screen":"product_carousel_h-screen__gMoLy","h-6":"product_carousel_h-6__U2CcH","min-h-[400px]":"product_carousel_min-h-__400px____Sgpq8","min-h-screen":"product_carousel_min-h-screen__AluCb","w-full":"product_carousel_w-full__M1jD6","w-6":"product_carousel_w-6__HfLIx","origin-top":"product_carousel_origin-top__nax4g","-translate-y-1":"product_carousel_-translate-y-1__plv1t","translate-y-0":"product_carousel_translate-y-0__oBb4_","scale-95":"product_carousel_scale-95__10qtf","scale-100":"product_carousel_scale-100__8Yets","scale-y-95":"product_carousel_scale-y-95__i3Kjo","scale-y-100":"product_carousel_scale-y-100__4nmok","transform":"product_carousel_transform__ocaDC","resize":"product_carousel_resize__UIkT7","items-center":"product_carousel_items-center__n3MFf","justify-between":"product_carousel_justify-between__Cw8OF","gap-2":"product_carousel_gap-2__UYQbp","rounded":"product_carousel_rounded__WxMkP","rounded-t-xl":"product_carousel_rounded-t-xl__rbMhk","bg-white":"product_carousel_bg-white__ZXGv9","bg-gradient-to-b":"product_carousel_bg-gradient-to-b__R1zGu","from-[#fff]":"product_carousel_from-____fff____YwmQu","to-[#E6E6E6]":"product_carousel_to-____E6E6E6____cXe0v","p-3":"product_carousel_p-3__kd_rd","p-1":"product_carousel_p-1__u6nJe","p-4":"product_carousel_p-4__iDx7f","px-4":"product_carousel_px-4__OPhXt","py-6":"product_carousel_py-6__6isdT","pb-4":"product_carousel_pb-4__dpN_8","pr-7":"product_carousel_pr-7__V5Yx4","pb-[216px]":"product_carousel_pb-__216px____zaNDs","text-center":"product_carousel_text-center__DtrD2","text-right":"product_carousel_text-right__ULAPp","align-top":"product_carousel_align-top__jNFqp","align-middle":"product_carousel_align-middle__3oc3k","text-xs":"product_carousel_text-xs__danzE","text-lg":"product_carousel_text-lg__pqfkU","text-input2":"product_carousel_text-input2__CuXGD","text-headline7":"product_carousel_text-headline7__ZRLPf","text-button-small":"product_carousel_text-button-small___EfDA","font-bold":"product_carousel_font-bold__95dXW","font-semibold":"product_carousel_font-semibold__zpu2I","text-tqm-red-primary":"product_carousel_text-tqm-red-primary__yqsFG","text-white":"product_carousel_text-white__hELTd","text-[#02A989]":"product_carousel_text-____02A989____9sivW","text-black":"product_carousel_text-black__HkKi8","text-gray-900":"product_carousel_text-gray-900__GIUee","!text-light-blue-500":"product_carousel___text-light-blue-500__3AiaS","underline":"product_carousel_underline__Nh298","opacity-0":"product_carousel_opacity-0__xf4lN","opacity-100":"product_carousel_opacity-100__Pn67k","shadow-xs":"product_carousel_shadow-xs___08qB","filter":"product_carousel_filter__VANgL","transition":"product_carousel_transition__Om0dS","transition-all":"product_carousel_transition-all__SMBK_","duration-100":"product_carousel_duration-100__nxsq_","duration-75":"product_carousel_duration-75__bcD0B","duration-200":"product_carousel_duration-200__1aSYO","duration-150":"product_carousel_duration-150__8rTjV","duration-300":"product_carousel_duration-300__S5udR","ease-out":"product_carousel_ease-out__jdlPy","ease-in":"product_carousel_ease-in__TAJXZ","product_carousel":"product_carousel_product_carousel__LM2lz","title":"product_carousel_title__OfzOv","skeleton_card":"product_carousel_skeleton_card__eYYXH","product_card":"product_carousel_product_card__XRmvh","product_image_wrapper":"product_carousel_product_image_wrapper__F6ics","product_details":"product_carousel_product_details__Q0DKS","tablet:block":"product_carousel_tablet__block__ays5F","tablet:max-w-[200px]":"product_carousel_tablet__max-w-__200px____mVMXQ","tablet:p-6":"product_carousel_tablet__p-6__0mIjn","tablet:text-xl":"product_carousel_tablet__text-xl__lacmX"};

/***/ }),

/***/ 77379:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"testimonial_carousel_sr-only__jZHiq","!static":"testimonial_carousel___static__BN3Lz","static":"testimonial_carousel_static__Y2V57","fixed":"testimonial_carousel_fixed__fKOrM","absolute":"testimonial_carousel_absolute__3qXfs","relative":"testimonial_carousel_relative__HUR4n","right-4":"testimonial_carousel_right-4__yLCnk","top-6":"testimonial_carousel_top-6__ZiTnt","z-40":"testimonial_carousel_z-40__MYeav","z-0":"testimonial_carousel_z-0__nPuBt","m-auto":"testimonial_carousel_m-auto__aHi53","my-1":"testimonial_carousel_my-1__IONcA","mt-4":"testimonial_carousel_mt-4__Fstnx","mt-0":"testimonial_carousel_mt-0___ehxS","mt-16":"testimonial_carousel_mt-16__k7_s3","block":"testimonial_carousel_block__uVeEi","inline-block":"testimonial_carousel_inline-block__ySuWN","inline":"testimonial_carousel_inline__FVBiN","flex":"testimonial_carousel_flex__FByYS","table":"testimonial_carousel_table__PgCSB","contents":"testimonial_carousel_contents__FfbCa","hidden":"testimonial_carousel_hidden__b9zwQ","h-screen":"testimonial_carousel_h-screen__eLIyC","h-6":"testimonial_carousel_h-6__5Bmv0","min-h-[400px]":"testimonial_carousel_min-h-__400px____1UAKt","min-h-screen":"testimonial_carousel_min-h-screen__bACwH","w-full":"testimonial_carousel_w-full__ixghS","w-6":"testimonial_carousel_w-6__P6HrG","origin-top":"testimonial_carousel_origin-top__nH30b","-translate-y-1":"testimonial_carousel_-translate-y-1__oWZEb","translate-y-0":"testimonial_carousel_translate-y-0__DPFcJ","scale-95":"testimonial_carousel_scale-95__vzMWj","scale-100":"testimonial_carousel_scale-100__NXhEA","scale-y-95":"testimonial_carousel_scale-y-95__pYS5V","scale-y-100":"testimonial_carousel_scale-y-100__IKcdL","transform":"testimonial_carousel_transform__ESBS_","resize":"testimonial_carousel_resize__u26Xn","items-center":"testimonial_carousel_items-center__F_ia_","justify-between":"testimonial_carousel_justify-between__9AhCu","gap-2":"testimonial_carousel_gap-2__3C_XA","rounded":"testimonial_carousel_rounded__uZR4x","rounded-t-xl":"testimonial_carousel_rounded-t-xl__xl10k","bg-white":"testimonial_carousel_bg-white__YChI_","bg-gradient-to-b":"testimonial_carousel_bg-gradient-to-b__KJxLg","from-[#fff]":"testimonial_carousel_from-____fff____BE_as","to-[#E6E6E6]":"testimonial_carousel_to-____E6E6E6____nAyhE","p-3":"testimonial_carousel_p-3__BepnQ","p-1":"testimonial_carousel_p-1__UPOeI","p-4":"testimonial_carousel_p-4__tosL2","px-4":"testimonial_carousel_px-4__k4U_R","py-6":"testimonial_carousel_py-6__StVHD","pb-4":"testimonial_carousel_pb-4__JouTe","pr-7":"testimonial_carousel_pr-7__CJfRr","pb-[216px]":"testimonial_carousel_pb-__216px____Bgw_3","text-center":"testimonial_carousel_text-center___eovW","text-right":"testimonial_carousel_text-right__HljIJ","align-top":"testimonial_carousel_align-top__MeAeF","align-middle":"testimonial_carousel_align-middle__MJA2E","text-xs":"testimonial_carousel_text-xs____9ca","text-lg":"testimonial_carousel_text-lg__IK8LI","text-input2":"testimonial_carousel_text-input2__C4amN","text-headline7":"testimonial_carousel_text-headline7__SIOFo","text-button-small":"testimonial_carousel_text-button-small__AnWP9","font-bold":"testimonial_carousel_font-bold__A84vj","font-semibold":"testimonial_carousel_font-semibold__PdAc9","text-tqm-red-primary":"testimonial_carousel_text-tqm-red-primary__Y5CeN","text-white":"testimonial_carousel_text-white__F8gzR","text-[#02A989]":"testimonial_carousel_text-____02A989____Xh2cO","text-black":"testimonial_carousel_text-black__xLPxJ","text-gray-900":"testimonial_carousel_text-gray-900__o0Hn2","!text-light-blue-500":"testimonial_carousel___text-light-blue-500__yEch2","underline":"testimonial_carousel_underline__UGolZ","opacity-0":"testimonial_carousel_opacity-0__PTpfK","opacity-100":"testimonial_carousel_opacity-100__TcvKw","shadow-xs":"testimonial_carousel_shadow-xs__t97Nc","filter":"testimonial_carousel_filter__Vn7Ck","transition":"testimonial_carousel_transition__8pU3u","transition-all":"testimonial_carousel_transition-all__nMmdP","duration-100":"testimonial_carousel_duration-100__gBzVn","duration-75":"testimonial_carousel_duration-75__35_8d","duration-200":"testimonial_carousel_duration-200__lB870","duration-150":"testimonial_carousel_duration-150__1dMZn","duration-300":"testimonial_carousel_duration-300__q0k_Z","ease-out":"testimonial_carousel_ease-out___KfQV","ease-in":"testimonial_carousel_ease-in__fD1qI","card":"testimonial_carousel_card__x5jTT","image_wrapper":"testimonial_carousel_image_wrapper__rH8Qz","detail":"testimonial_carousel_detail__yaHML","user_name":"testimonial_carousel_user_name__yBEwf","testimonial_carousel":"testimonial_carousel_testimonial_carousel__4pGw6","tablet:block":"testimonial_carousel_tablet__block__DjgiD","tablet:max-w-[200px]":"testimonial_carousel_tablet__max-w-__200px____nEhQc","tablet:p-6":"testimonial_carousel_tablet__p-6__m5AX6","tablet:text-xl":"testimonial_carousel_tablet__text-xl__92D3n"};

/***/ }),

/***/ 55898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"style_sr-only__hh6NF","!static":"style___static__V4fhW","static":"style_static__Dx4OP","fixed":"style_fixed__7ojo7","absolute":"style_absolute__biqDe","relative":"style_relative__FuQ1E","right-4":"style_right-4__teKYg","top-6":"style_top-6__5OayZ","z-40":"style_z-40__TcGO6","z-0":"style_z-0__GbAu_","m-auto":"style_m-auto__UwG0p","my-1":"style_my-1__Byy32","mt-4":"style_mt-4__SCtut","mt-0":"style_mt-0__6JdIj","mt-16":"style_mt-16__cBG9d","block":"style_block__T0GXC","inline-block":"style_inline-block__dyQnG","inline":"style_inline__wFgA3","flex":"style_flex__JMxqS","table":"style_table___Ipwx","contents":"style_contents__UnQOy","hidden":"style_hidden__qXPeQ","h-screen":"style_h-screen__fXbu9","h-6":"style_h-6__sOBF7","min-h-[400px]":"style_min-h-__400px____EGIWA","min-h-screen":"style_min-h-screen__LIzi0","w-full":"style_w-full___hIm7","w-6":"style_w-6__qCN49","origin-top":"style_origin-top__fxWTL","-translate-y-1":"style_-translate-y-1__etjXT","translate-y-0":"style_translate-y-0__0ZtxD","scale-95":"style_scale-95__PJvIw","scale-100":"style_scale-100__xPrmU","scale-y-95":"style_scale-y-95__AWp3K","scale-y-100":"style_scale-y-100__IxmWq","transform":"style_transform__cJzFp","resize":"style_resize__Bbevr","items-center":"style_items-center__zM5Hk","justify-between":"style_justify-between__lg1g2","gap-2":"style_gap-2__7TGvX","rounded":"style_rounded___SSSL","rounded-t-xl":"style_rounded-t-xl__aAC2u","bg-white":"style_bg-white__cRKhx","bg-gradient-to-b":"style_bg-gradient-to-b__57FqH","from-[#fff]":"style_from-____fff____RrVkz","to-[#E6E6E6]":"style_to-____E6E6E6____uElAp","p-3":"style_p-3__S6LtF","p-1":"style_p-1__ayO_A","p-4":"style_p-4___3pzV","px-4":"style_px-4__UEiiO","py-6":"style_py-6__45OnA","pb-4":"style_pb-4__bERLU","pr-7":"style_pr-7__BcQCP","pb-[216px]":"style_pb-__216px____EmuJe","text-center":"style_text-center__g4zTM","text-right":"style_text-right__bwNSK","align-top":"style_align-top__G_lXx","align-middle":"style_align-middle__tl_a8","text-xs":"style_text-xs__NQ0pA","text-lg":"style_text-lg__yGAUQ","text-input2":"style_text-input2__vlNUM","text-headline7":"style_text-headline7__mHFiO","text-button-small":"style_text-button-small__10C7k","font-bold":"style_font-bold__EubHI","font-semibold":"style_font-semibold__eXnlH","text-tqm-red-primary":"style_text-tqm-red-primary__zUZ4U","text-white":"style_text-white__TozTb","text-[#02A989]":"style_text-____02A989____dmE3P","text-black":"style_text-black__jGhIT","text-gray-900":"style_text-gray-900__dmQnO","!text-light-blue-500":"style___text-light-blue-500__EVBWr","underline":"style_underline___xzer","opacity-0":"style_opacity-0__UGGow","opacity-100":"style_opacity-100__pD8s5","shadow-xs":"style_shadow-xs___89ho","filter":"style_filter__PiSzN","transition":"style_transition__0BgPH","transition-all":"style_transition-all__dRfx6","duration-100":"style_duration-100__9GWZT","duration-75":"style_duration-75__lzmOT","duration-200":"style_duration-200__SO0bH","duration-150":"style_duration-150__yr6rj","duration-300":"style_duration-300__NnqiI","ease-out":"style_ease-out___ERUK","ease-in":"style_ease-in__ZhaxF","main_cta_section":"style_main_cta_section__nZADg","main_cta_background":"style_main_cta_background__gwxkb","main_cta_container":"style_main_cta_container__h168y","partner_insurer_section":"style_partner_insurer_section__s4oZe","article_section":"style_article_section__JTehP","article_container":"style_article_container__cuvXT","title":"style_title__RDHG0","buy_step_section":"style_buy_step_section__yMVRf","curation_carousel_section":"style_curation_carousel_section__nTgYO","curation_carousel_container":"style_curation_carousel_container__TvJQo","anchor":"style_anchor__mw4Wz","product_carousel_section":"style_product_carousel_section__J1_oz","product_carousel_container":"style_product_carousel_container__h_D9_","product_carousel":"style_product_carousel__Ul7ol","testimonial_section":"style_testimonial_section__fsgKz","testimonial_container":"style_testimonial_container__FutQc","testimonial":"style_testimonial__QG1hj","customers_testimonial":"style_customers_testimonial__a3_bj","partner_section":"style_partner_section__KRfqv","partner_container":"style_partner_container__OApYp","desktop_title":"style_desktop_title__UJmLy","event_section":"style_event_section__BhruB","event_container":"style_event_container__r7bUP","tablet:block":"style_tablet__block__FANUX","tablet:max-w-[200px]":"style_tablet__max-w-__200px_____Y8Ho","tablet:p-6":"style_tablet__p-6__uXHpM","tablet:text-xl":"style_tablet__text-xl__FRuZr"};

/***/ })

}]);